export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CLEAR_ALL_FROM_CART = "CLEAR_ALL_FROM_CART";
